<template>
  <div class="pic-tree">
    <PICTreeItem
      v-for="node in nodes"
      :key="node.id"
      :node="node"
      :highlight-ids="highlightIds"
      :selected-id="selectedId"
      @select="onSelect"
    />
  </div>
</template>

<script>

import PICTreeItem from "./PICTreeItem.vue";

export default {

  name: "PICTree",
  components: {
    PICTreeItem
  },
  props: {
    nodes: {
      type: Array,
      default: () => []
    },

    //nodo da evidenziare (ricerca multipla)
    highlightIds: {
      type: Array,
      default: () => []
    },
    selectedId: {
      type: [Number, String],
      default: null
    }
  },
 
  methods: {

    onSelect(node) {

      // SOLO forward evento al parent (PICPiani)
      this.$emit("select", node);
    }
  }
};

</script>

<style scoped>

.pic-tree {
  width: 100%;
  font-size: 14px;
}

</style>